import Env from '../../env';

export function useUnifiedTicketValidityDisplay(env: Env): boolean {
    return !!(
        env.FORMATTING?.USE_SETTINGS_DATE_FORMAT_FOR_ALL_LANGUAGE || env.FORMATTING?.UNIFIED_TICKET_VALIDITY_DISPLAY
    );
}

/** Intl dateTimeRange when PERIOD_TICKET_VALIDITY is configured and unified ridangoDateTime path is off. */
export function useIntlPeriodTicketValidityDisplay(env: Env): boolean {
    return !useUnifiedTicketValidityDisplay(env) && !!env.FORMATTING?.PERIOD_TICKET_VALIDITY;
}
